import Vue from "vue";
import Vuex from "vuex";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import DefaultState from "./default_state.js";
Vue.use(Vuex);

let debug = process.env.VUE_APP_NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
    ...DefaultState
  },
  actions,
  mutations,
  getters,
  strict: debug
});
